import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PER_Employees = _resolveComponent("PER_Employees")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_PER_EmployeesDetails = _resolveComponent("PER_EmployeesDetails")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createBlock(_component_v_row, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_col, { cols: "6" }, {
        default: _withCtx(() => [
          _createVNode(_component_PER_Employees, { onSelectionChanged: $options.handleSelectionChanged }, null, 8, ["onSelectionChanged"])
        ]),
        _: 1
      }),
      _createVNode(_component_v_col, { cols: "6" }, {
        default: _withCtx(() => [
          ($data.selectedEmpId)
            ? (_openBlock(), _createBlock(_component_PER_EmployeesDetails, {
                key: 0,
                "employee-id": $data.selectedEmpId,
                "employee-row": $data.selectedRow
              }, null, 8, ["employee-id", "employee-row"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}